import React, { useState, useEffect } from 'react';

import WebResultFAQ from './WebResultFAQ';
import utils from '../../utils';
import config from '../internetConfig';
import metrics from '../internetMetrics';
import __ from '../internetLanguage';

export default function WebResult(props) {
	const result = Object.assign({}, props && props.result);
	const query = props.query;
	const resultIndex = props.resultIndex;
	const title = result.title || '';
	const description = result.description || '';
	const date = result.date || '';
	const jsonlds = result.jsonld ? utils.toArray(result.jsonld) : [];
	const page = utils.toNumber(props.page);
	const totalIndex = (page - 1) * config.pageSize + resultIndex + 1

	// click tracking metrics
	const metricsProps = {
		eVar18: result.url,
		eVar19: totalIndex,
		eVar20: page,
		eVar63: utils.cleanTerm(props.query),
		prop40: result.bb ? 'click-result-bb' : 'click-result',
	};

	const setSearchCookie = (event, searchText) => {
		event.preventDefault();
		metrics.event(event, 'cdcsitesearch-link-readmore', metricsProps)
		let cookieDate = new Date();
		// Need to remove Bold Tags from string as they interfere with search scroll
		var outputString = String(searchText).substring(0, 80).trim().replace(/(<\/?b>|[;=])/gi,'');
		cookieDate.setTime( cookieDate.getDate() + 1 );
		let expires = `expires=${cookieDate.toUTCString()}`;
		let domain = '.cdc.gov';
		document.cookie = `cdc-search-text=${outputString}; expire = ${expires}; domain = ${domain}; path =/;`;
		console.info(`Search: cdc-search-text=${outputString}`);
		window.location.href = event.target.href;
	}

	//specific date formatting
	const dateArr = date.split('-');
	let month = '';
	let day = '';
	const numMonth = parseInt(dateArr[1]);
	month = utils.formatMonth(numMonth);
	day = dateArr[2] ? parseInt(dateArr[2], 10) : '';
	const formattedDate = dateArr[0] !== '' ? month + ' ' + day + ', ' + dateArr[0] : '';

	// get result file type
	const deepLink = config.deepLink;
	const fileType = String(utils.getResultFileType(result)).toUpperCase();
	const target = (fileType) ? '_blank' : '_self';

	let widget = '';
	let faqData = null;
	if (jsonlds.length) {
		jsonlds.forEach((jsonld) => {
			try {
				let data = JSON.parse(jsonld);
				let type = data && data['@type'];
				if (Array.isArray(data.mainEntity) && data.mainEntity.length && 'FAQPage' === type) {
					faqData = data.mainEntity;
				}
			} catch (error) {
				config.debug && console.error('Search: error parsing FAQ: ', error);
			}
		});
	}
	if (faqData) {
		widget = <WebResultFAQ faqData={faqData} resultIndex={resultIndex} query={query}></WebResultFAQ>;
	}

	return (
		<div className={'result' + (result.bb ? ' result-bestbet' : '')}>
			<div className="result-title d-flex">
				<a href={result.url} target={target} onClick={(e) => metrics.event(e, 'cdcsitesearch-link', metricsProps)}>
					{fileType ? (
						<span>
							<small>[{fileType.toUpperCase()}]</small>
							<span dangerouslySetInnerHTML={{ __html: title }}></span>
						</span>
					) : (
						<span dangerouslySetInnerHTML={{ __html: title }}></span>
					)}
				</a>
			</div>
			<div className='result-url-container'>
			{config.debug &&
				<div className="result-url">
					<a href={result.url} target={target} onClick={(e) => metrics.event(e, 'cdcsitesearch-link', metricsProps)}>
						{result.url}
					</a>
					 <span className="pill">{result.score}</span>
				</div>
			}
			</div>
			<div className="result-description">
				<span dangerouslySetInnerHTML={{ __html: description }}></span>
				{ deepLink ? (
						<span className="result-read-more">
							<a href={result.url} target={target} onClick={(e) => setSearchCookie(e, result.description)}>{__('viewInPage')} <i className='cdc-fa-circle-arrow-right'></i></a>
						</span>
					) :
						''
				}
			</div>
			{widget}
			<div className="ml-auto d-md-flex result-date" dangerouslySetInnerHTML={{__html: formattedDate }}></div>
		</div>
	);
}
